import { Deserializer } from "jsonapi-serializer";
import { CREATED, INTERNAL_SERVER_ERROR, NO_CONTENT, OK } from "../constants/response-status-codes";
import { Controller } from "../models/Controller";
import { genericError } from "../models/GenericError";
import { StoreEntityResult } from "../models/services/StoreEntityResult";
import { APIConnector } from "./api/APIConnector";
import { getConstraintViolation, processServerError } from "./utilities/ServiceError";

const apiConnector = new APIConnector();

export const installController = async (controller: Controller, userId: string, installController = true) => {
    try {
        const newRecord = {
            data: {
                type: "installDevice",
                id: "0",
                attributes: {
                    autoCreateDoorsType: controller.autoCreateDoors ? controller.autoCreateDoorsType : null,
                    autoInstallPeripherals: controller.selectedPeripherals && controller.selectedPeripherals?.length === 0 ? true : false,
                    discoveryId: controller.id,
                    fixedAddress: controller.fixedAddress,
                    macAddress: controller.macAddress,
                    siteId: controller.siteId,
                    userLoginId: userId,
                    cmdSubType: 'CONTROLLER',
                    peripheralAddressesRS485: controller.selectedPeripherals ? controller.selectedPeripherals : [],
                    peripheralAddressesIP: controller.selectIPDevices ? controller.selectIPDevices : [],
                    baseDeviceName: controller.name,
                    typeName: controller.typeName,
                    deviceTypeId: controller.typeId
                },
            }
        }

        const url = `installDevice${installController ? '' : `/${newRecord.data.id}`}`;
        let response: Response;

        await apiConnector.sendData(url, installController, newRecord).then(data => {
            response = data;
        }).catch(error => {
            return new Promise((resolve, reject) => {
                reject({ status: response.status, message: genericError })
            })
        });

        return new Promise<StoreEntityResult>(async (resolve, reject) => {
            if (response) {
                if (installController) {
                    const content = await response.json();
                    if (content.errors) {
                        return reject({ status: response.status, message: getConstraintViolation(content.errors[0].detail) })
                    }

                    new Deserializer().deserialize(content, (error, controller) => {
                        if (error) {
                            return reject({ status: response.status, id: controller.id, success: false, message: genericError });
                        }
                        return resolve({ id: controller.id, success: true });
                    })

                    return;
                }

                if (response.status === NO_CONTENT) {
                    return resolve({ id: controller.id, success: true })
                }
                const json = await response.json();
                return reject({ status: response.status, id: controller.id, success: false, message: getConstraintViolation(json.errors[0].detail) });
            }
            return reject({ status: INTERNAL_SERVER_ERROR, id: controller.id, success: false, message: genericError });
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}

export const installBiometric = async (biometric: string[], installBiometric = true) => {
    try {
        const newRecord = {
            data: {
                type: "installDevice",
                id: "1",
                attributes: {
                    cmdSubType: "IDEMIA",
                    biometricDevices: biometric,
                }
            }
        }
        const url = `installDevice`;

        const response = await apiConnector.sendData(url, installBiometric, newRecord)

        return new Promise<StoreEntityResult>(async (resolve, reject) => {
            if (response && (response.status === OK || response.status === CREATED)) {
                return resolve({ id: 0, success: true });
            }

            const content = await response.json();
            return reject({ status: response.status, id: 0, success: false, message: getConstraintViolation(content.errors[0].detail) });
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error)) ;
        });
    }
}

